export const resolveTwoLetterCode = (language: string) => {
  switch (language) {
    case "eng":
      return "en";
    case "fin":
      return "fi";
    case "sme":
    case "smn":
    case "sms":
      return "se";
    case "swe":
      return "sv";
    default:
      return language;
  }
};

export const resolveHardOfHearingLabel = (languageCode: string) => {
  switch (languageCode) {
    case "fi":
      return "ohjelmatekstitys";
    case "sv":
      return "programtextning";
    default:
      return "";
  }
};

export const resolveTranslationLabel = (languageCode: string) => {
  switch (languageCode) {
    case "fi":
      return "käännöstekstitys";
    case "sv":
      return "översättning";
    case "en":
      return "subtitles";
    default:
      return "";
  }
};
